<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container">
    <a data-testid="navbar-title" class="navbar-brand" routerLink="/">
      <app-navbar-logo />
      Geneva Protection
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="/login"
            >Connexion</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="/signup">
            Inscription
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
